/**
 * モーダル
 */

import $ from 'jquery';

$(function () {
  // モーダルHTML要素を動的に作成
  if ($('#js-modal').length === 0) {
    $('body').append(`
      <div id="js-modal" class="c-modal" style="display: none;">
        <button class="c-modal__close js-modal-close"></button>
        <div class="c-modal__content">
          <img class="c-modal__img" src="" alt="">
          <p class="c-modal__txt"></p>
        </div>
      </div>
    `);
  }

  const $modal = $('#js-modal');
  const $modalImg = $modal.find('.c-modal__img');
  const $modalTxt = $modal.find('.c-modal__txt');

  // モーダルを開く
  $('.js-modal-open').on('click', function () {
    const imgSrc = $(this).data('modal-image');
    const txt = $(this).find('.c-accepted-item__txt').text();

    // すでにモーダルが開いている場合は一度閉じてから開き直す
    if ($modal.is(':visible')) {
      $modal.css({
        transform: 'scale(0.7)',
        opacity: 0,
      });

      setTimeout(function () {
        openModal(imgSrc, txt);
      }, 100);
    } else {
      openModal(imgSrc, txt);
    }
  });

  // モーダルを開く関数
  function openModal(imgSrc, txt) {
    // モーダルに内容をセット
    $modalImg.attr('src', imgSrc);
    $modalTxt.text(txt);

    $modal.css({
      display: 'flex',
      opacity: 0,
      transform: 'scale(0.7)',
      transition: 'transform 0.4s ease, opacity 0.2s ease',
    });

    setTimeout(function () {
      $modal.css({
        transform: 'scale(1)',
        opacity: 1,
      });
    }, 10);
  }

  // モーダルを閉じる
  function closeModal() {
    $modal.css({
      transform: 'scale(0.7)',
      opacity: 0,
    });

    setTimeout(function () {
      $modal.css({
        display: 'none',
        transition: '',
      });
    }, 300);
  }

  // 閉じるボタンクリック
  $(document).on('click', '.js-modal-close', closeModal);

  // モーダルの背景クリックで閉じる（オプション）
  $(document).on('click', '#js-modal', function (e) {
    if (e.target === this) {
      closeModal();
    }
  });

  // Escキーで閉じる
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $modal.is(':visible')) {
      closeModal();
    }
  });
});
